






































import Vue from 'vue'
import Editor from '@tinymce/tinymce-vue'
import BaseIcon from '../svgicons/BaseIcon.vue'
import { CommentService } from '@/services/'
import { editorConfig } from '@/helper/constants'
import { COMMENT_MAX_LENGTH } from '@/helper/constants'
import UISpinner from '../common/UISpinner.vue'

export default Vue.extend({
  data() {
      return {
          replyText: "",
          posting: false
      }
  },
  props: {
      parentCommentId: {
          type: String
      },
      repliedToComment: {
          type: String
      },
      repliedToUserId: {
          type: String
      },
      pendoPayload: {
        type: Object
      }
  },
  computed: {
    commentCharacterLength() {
      return COMMENT_MAX_LENGTH || 140
    },
    postButtonDisabled() {
      return this.replyTextLength > 140 || this.replyTextLength === 0
    },
    editorConfig() {
      return editorConfig
    },
    postId() {
      return this.$route.params.post_id
    },
    productId() {
      return this.$route.params.id
    },
    replyTextLength() {
      return this.replyText.replace(/<\/?[^>]+(>|$)/g, "").replace(/&nbsp;/g, ' ').length
    }
  },
  components: {
      editor: Editor,
      BaseIcon,
      UISpinner
  },
  methods: {
    closeReplyModal() {
      this.$emit("closeReplyModal")
    },
    async replytoComment() {
      try {
        this.posting = true
        const { data: repliedComment } = await CommentService.createComment({
          postId: this.postId,
          productId: this.productId,
          content: this.replyText,
          parentCommentId: this.parentCommentId,
          repliedToComment: this.repliedToComment,
          repliedToUserId: this.repliedToUserId,
          pendoPayload: {
            postTitle: this.pendoPayload.post.title,
            productTitle: this.pendoPayload.product.title,
            categoryTitle: this.pendoPayload.category.title 
          }
        })
        this.posting = false
        this.$bus.$emit("addNewReplyToState", repliedComment.comment)
        this.$emit("closeReplyModal")
      } catch (error) {
        console.error("Something went wrong", error)
      }
    }
  }
})
